import React, { Component } from 'react'
import { Row, Col, Input, Button, Form, Popconfirm, Table, Modal, Spin, Radio, Cascader } from 'antd'
import _ from 'underscore'
import Card from '../../components/Card'
import { api, app, config } from "../../app"
import addressOptions from '../../util/cascader-address-options'
import utils from "../../utils"

const FormItem = Form.Item
const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class TeamAddress extends Component {
    constructor (props) {
        super(props)
        this.state = {
            editTeam: {},
            teamList: [],
            data_load_index: 0,
            proList: [],
            all_province: [],
            pro_loading: true,
            data_loading: true,
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.handleProData()
        await this.handleTeamData(0)
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 设置值
     * @param data
     * @param cb
     */
    setData = async (data) => {
        await app.setStateSync(this, data)
    }

    /**
     * 省份数据
     * @returns {Promise<void>}
     */
    handleProData = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, data, msg } = await app.post(api.ProvinceData, params)
        if (flag !== 1) {
            app.alert(msg, "warn")
            data = []
        }
        await this.setData({ proList: utils.addArrayKey(data), all_province: data, pro_loading: false })
    }

    /**
     * 获取队伍数据
     * @param data_load_index
     * @returns {Promise<any.data>}
     */
    handleTeamData = async (data_load_index) => {
        let { proList } = this.state, pro = proList[data_load_index], params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            area_name: pro.area_name,
            status: pro.status,
        }
        await this.setData({ data_loading: true, data_load_index })
        let { flag, data, msg } = await app.post(api.TeamData, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (data_load_index === this.state.data_load_index) {
            await this.setData({ teamList: utils.addArrayKey(data), data_loading: false })
        }
    }

    /**
     * 删除地址
     * @param teamno
     * @returns {Promise<void>}
     */
    handleDeleteTeam = async (teamno) => {
        let params = {
            teamno,
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        }
        let { flag, msg } = await app.post(api.TeamAddressDel, params)
        if (flag === 1) {
            app.alert("删除成功", "success")
            await this.handleTeamData(this.state.data_load_index)
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 获取省地址数据
     * @param data_load_index
     * @returns {Promise<any.data>}
     */
    handleProAddressData = async () => {
        let { proList, data_load_index } = this.state, pro = proList[data_load_index], params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
            multeam_name: pro.multeam_name,
        }
        let { flag, data, msg } = await app.post(api.TeamEditProvinceData, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = {}
        }
        data.teamname = pro.area_name
        return data
    }

    /**
     * 搜索
     * @param value
     */
    handleSearch = async (value) => {
        let { all_province } = this.state
        let proList = []
        if (value) {
            proList = _.filter(all_province, (obj) => {
                return obj.area_name.indexOf(value) !== -1
            })
        } else {
            proList = all_province
        }
        await this.setState({ proList })
        if (proList.length > 0) {
            await this.handleTeamData(0)
        }
    }


    /**
     * 队伍选择
     **/
    handleSelectPro = async (e) => {
        let { value } = e.target
        await this.handleTeamData(value)
    }

    /**
     * 关闭编辑
     * @returns {Promise<void>}
     */
    handleCloseEdit = async () => {
        await this.setData({ edit_modal: false, edit_loading: false })
        this.props.form.resetFields()
    }

    /**
     * 打开编辑
     * @returns {Promise<void>}
     */
    handleOpenEdit = async (type, item) => {
        let state = { edit_modal: true }
        if (type === 1) {
            await this.setData({ pc_loading: true })
            item = await this.handleProAddressData()
            item.type = 2
            state.pc_loading = false
        }
        if (item.province) {
            let values = {
                name: item.name,
                mobile: item.mobile,
                city: [item.province, item.city, item.region],
                address: item.address,
                address_status: item.address_status === "2" ? "2" : "1",
            }
            console.log(values)
            if (item.address_status === "2") {
                values.vice_name = item.vice_name
                values.vice_mobile = item.vice_mobile
                values.vice_city = [item.vice_province, item.vice_city, item.vice_region]
                values.vice_address = item.vice_address
            }
            this.props.form.setFieldsValue(values)
        }
        state.editTeam = item
        await this.setData(state)
    }

    /**
     * 提交编辑
     * @returns {Promise<void>}
     */
    handleSubmitEdit = async () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                await this.setData({ edit_loading: true })
                let { editTeam } = this.state, city = values.city, params = {
                    indexno: app.getData("indexno"),
                    account: app.getData("account"),
                    type: editTeam.type,
                    teamno: editTeam.teamno,
                    province: city[0],
                    city: city[1],
                    region: city[2],
                    address: values.address,
                    name: values.name,
                    mobile: values.mobile,
                    address_status: values.address_status
                }
                if (values.address_status === "2") {
                    let vice_city = values.vice_city
                    params.vice_name = values.vice_name
                    params.vice_mobile = values.vice_mobile
                    params.vice_province = vice_city[0]
                    params.vice_city = vice_city[1]
                    params.vice_region = vice_city[2]
                    params.vice_address = values.vice_address

                }
                let { flag, msg } = await app.post(api.TeamAddressEdit, params)
                if (flag === 1) {
                    app.alert("编辑成功", "success")
                    await this.handleCloseEdit()
                    await this.handleTeamData(this.state.data_load_index)
                } else {
                    app.alert(msg, "error")
                    await this.setData({ edit_loading: false })
                }
            }
        })
    }

    /**
     * 导出
     */
    handleExport = () => {
        app.downFile(config.serverUrl + api.TeamAddressExport + `?token=${app.getToken()}&indexno=${app.getData('indexno')}&account=${app.getData('account')}`)
    }

    render () {
        let formItemLayout = {
                labelCol: { span: 4 },
                wrapperCol: { span: 18, offset: 1 },
            },
            { getFieldDecorator, getFieldValue, getFieldsValue, setFieldsValue } = this.props.form,
            { editTeam, edit_loading, pro_loading, proList, data_load_index, edit_modal, teamList, data_loading } = this.state,
            province = proList[data_load_index] || {},
            address_status = getFieldValue('address_status'),
            rights = app.getData('rights'),
            node1 = (
                <div hidden={address_status !== "2"}>
                    <FormItem
                        {...formItemLayout}
                        label="收货人姓名"
                    >
                        {getFieldDecorator('vice_name', {
                            rules: [{
                                required: address_status === "2", message: '请输入收货人姓名',
                            }],
                        })(
                            <Input/>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="联系电话"
                    >
                        {getFieldDecorator('vice_mobile', {
                            rules: [{
                                required: address_status === "2", message: '请输入联系电话',
                            }],
                        })(
                            <Input/>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="所在城市"
                    >
                        {getFieldDecorator('vice_city', {
                            rules: [{
                                required: address_status === "2", message: '请选择城市',
                            }],
                        })(
                            <Cascader options={addressOptions} placeholder="选择城市" showSearch={{
                                filter: (inputValue, path) => {
                                    return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))
                                }
                            }} notFoundContent="无记录"/>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="收货地址"
                    >
                        {getFieldDecorator('vice_address', {
                            rules: [{
                                required: address_status === "2", message: '请输入收货地址',
                            }],
                        })(
                            <Input.TextArea autosize={{ minRows: 2, maxRows: 2 }}/>
                        )}
                    </FormItem>
                </div>
            ),
            columns = [
                {
                    title: '序号',
                    dataIndex: 'xh',
                    key: 'xh',
                    width: '5%',
                    render (text, record, index) {
                        return (<span>{index + 1}</span>)
                    }
                },
                {
                    title: '队伍名称',
                    dataIndex: 'teamname',
                    key: 'teamname',
                    width: '15%',
                },
                {
                    title: '收货人姓名',
                    // dataIndex: 'name',
                    key: 'name',
                    width: '10%',
                    render: text => (<span>{text.address_status == "1" ? text.name || '' : text.vice_name}</span>)
                },
                {
                    title: '收货人电话',
                    // dataIndex: 'mobile',
                    key: 'mobile',
                    width: '15%',
                    render: text => (<span>{text.address_status == "1" ? text.mobile || '' : text.vice_mobile}</span>)
                },
                {
                    title: '城市',
                    // dataIndex: 'city',
                    key: 'city',
                    width: '15%',
                    render: (text) => {
                        if (text.city) {
                            return (<span>{text.address_status == "1" ? text.city + '/' + text.region : text.vice_city + '/' + text.vice_region}</span>)
                        }
                        return null
                    }
                },
                {
                    title: '详细地址',
                    // dataIndex: 'address',
                    key: 'address',
                    width: '15%',
                    render: text => (<span>{text.address_status == "1" ? text.address || '' : text.vice_address}</span>)
                },
                {
                    title: '是否一致',
                    dataIndex: 'address_status',
                    key: 'address_status',
                    width: '10%',
                    render: (text, { name }) => name ? (text === "1" ? "是" : "否") : ""
                },
                {
                    title: '操作',
                    dataIndex: 'teamno',
                    key: 'teamno',
                    width: '15%',
                    render: (teamno, item) => {
                        item.type = 1
                        return (
                            <span>
                                <Button size="small" onClick={() => this.handleOpenEdit(2, item)}>编辑</Button>
                                <Popconfirm title="确认删除吗？" okText="确定" cancelText="取消"
                                            onConfirm={() => this.handleDeleteTeam(teamno)}>
                                    <Button size="small" type="danger" style={{ marginLeft: 10 }}>删除</Button>
                                </Popconfirm>
                            </span>
                        )
                    }
                },
            ]
        // console.log(rights)
        return (
            <div className="team-editor">
                <div className="top-title">队部地址</div>
                <Row className="content">
                    <Col span={6} className="team-select">
                        <Card width="100%" height="100%" title="省份选择" style={{
                            padding: 25,
                            height: 'calc(100% - 68px)',
                        }}>
                            {
                                pro_loading ?
                                    (<Row className="data-loading" type="flex" align="middle" justify="center">
                                        <Spin size="small"/>
                                    </Row>) :
                                    (<div style={{ height: '100%' }}>
                                            <Input.Search
                                                placeholder="搜索"
                                                onSearch={this.handleSearch}
                                                className="search"
                                            />
                                            <RadioGroup onChange={this.handleSelectPro} className="team-list"
                                                        value={data_load_index}>
                                                {
                                                    proList.length > 0 ?
                                                        proList.map((pro, index) => {
                                                            return (
                                                                <RadioButton key={index} className='no-select'
                                                                             value={index}>
                                                                    <div title={pro.area_name}>{pro.area_name}</div>
                                                                </RadioButton>
                                                            )
                                                        }) : (
                                                            <p style={{ textAlign: "center", padding: "20px 0" }}>无对应省份</p>)
                                                }
                                            </RadioGroup>
                                        </div>
                                    )
                            }
                        </Card>
                    </Col>
                    <Col span={17} offset={1} className="team-info">
                        <Card width="100%" height="100%" style={{ padding: 25, height: 'calc(100% - 68px)' }} title={
                            <Row type="flex" justify="space-between" align="middle">
                                <Col>信息</Col>
                                <Col>
                                    {rights === 1 ? (<Button type="primary"
                                                             onClick={() => this.handleExport()}>导出队部收货地址</Button>) : null}
                                    {/* {province.status === 1 ? (<Button type="primary" style={{marginLeft: 20}}
                                                                      onClick={() => this.handleOpenEdit(1)}>编辑省管理员地址</Button>) : null} */}
                                </Col>
                            </Row>
                        }>
                            <Table className="ranks_address_table"
                                   locale={app.tbLocale(data_loading)}
                                   columns={columns}
                                   dataSource={teamList}
                                   loading={data_loading}
                                   pagination={false}
                                   scroll={{ y: "calc(100% - 38px)" }}
                                   size="small"
                            />
                        </Card>
                    </Col>
                </Row>
                <Modal
                    visible={edit_modal}
                    title={`编辑 [${editTeam.teamname}] 收货地址`}
                    maskClosable={false}
                    keyboard={false}
                    onCancel={this.handleCloseEdit}
                    onOk={this.handleSubmitEdit}
                    confirmLoading={edit_loading}
                    width={600}
                    okText="确定"
                    cancelText="取消"
                >
                    <Form onSubmit={this.handleEditTeam}>
                        <FormItem
                            {...formItemLayout}
                            label="收货人姓名"
                        >
                            {getFieldDecorator('name', {
                                rules: [{
                                    required: true, message: '请输入收货人姓名',
                                }],
                            })(
                                <Input/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="联系电话"
                        >
                            {getFieldDecorator('mobile', {
                                rules: [{
                                    required: true, message: '请输入联系电话',
                                }],
                            })(
                                <Input/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="所在城市"
                        >
                            {getFieldDecorator('city', {
                                rules: [{
                                    required: true, message: '请选择城市',
                                }],
                            })(
                                <Cascader options={addressOptions} placeholder="选择城市" showSearch={{
                                    filter: (inputValue, path) => {
                                        return (path.some(option => (option.label).toLowerCase().indexOf(inputValue.toLowerCase()) > -1))
                                    }
                                }} notFoundContent="无记录"/>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label={editTeam.type === 1 ? "队部地址" : "收货地址"}
                        >
                            {getFieldDecorator('address', {
                                rules: [{
                                    required: true, message: '请输入收货地址',
                                }],
                            })(
                                <Input.TextArea autosize={{ minRows: 2, maxRows: 2 }}/>
                            )}
                        </FormItem>
                        <div hidden={editTeam.type !== 1}>
                            <div style={{ marginBottom: 24, textAlign: 'center' }}>
                                <span style={{ color: 'rgba(0,0,0,.85)', marginRight: 20 }}>队部地址与制式装备收货地址是否一致: </span>
                                {getFieldDecorator('address_status', {
                                    initialValue: "1"
                                })(
                                    <RadioGroup onChange={(e) => {
                                        let { value } = e.target
                                        if (value === "2") {
                                            let values = getFieldsValue(["name", "mobile"])
                                            setFieldsValue({
                                                vice_name: values.name,
                                                vice_mobile: values.mobile,
                                            })
                                            console.log(values)
                                        } else {

                                        }
                                    }}>
                                        <Radio value="1">是</Radio>
                                        <Radio value="2">否</Radio>
                                    </RadioGroup>
                                )}
                            </div>
                            {node1}
                        </div>
                    </Form>
                    <p style={{
                        textAlign: 'center',
                        color: 'red'
                    }}>{editTeam.type === 1 ? "注: 队部收货地址用于各队胸标等产品收发。" : "注: 省管理员收货地址用于该省各队工作证收发。"} </p>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(TeamAddress)



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamAddress.jsx